import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-tab',
  templateUrl: './item-tab.component.html',
  styleUrls: ['./item-tab.component.scss']
})

export class ItemTabComponent implements OnInit {
  activeTab = 'items';

  constructor() { }

  ngOnInit() {
  }
}
